import React from 'react';
import {ButtonBase} from '@mui/material';
import {TEXTE} from '../../tokens.js';

// Styles partagés des composants de l'écran Carte (valeurs exactes de Carte.dc.html).

export const CHAMP_PILULE = {
    height: 32, padding: '0 10px', border: '1px solid #D5DAE1', borderRadius: 999, background: '#FFFFFF',
    font: 'inherit', fontSize: 13, color: TEXTE, boxSizing: 'border-box',
};

export const LIBELLE_CHAMP = {display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#6B7480'};

export const TITRE_SECTION_STYLE = {
    margin: 0, fontSize: 12, fontWeight: 700, letterSpacing: '.12em', textTransform: 'uppercase', color: '#8A929C',
};

/** Bouton pilule blanc 32 px (Copier le permalien, CSV, GeoJSON). */
export function BoutonPilule({children, onClick, disabled, icone, ...reste}) {
    return (
        <ButtonBase
            disabled={disabled}
            onClick={onClick}
            sx={{
                height: 32, px: '12px', gap: '6px', border: '1px solid', borderColor: disabled ? '#E3E7EC' : '#D5DAE1', borderRadius: '999px',
                backgroundColor: '#FFFFFF', fontSize: 12, fontWeight: 600, color: disabled ? '#9A9A9A' : TEXTE,
            }}
            {...reste}
        >
            {icone}
            {children}
        </ButtonBase>
    );
}

const svg = (enfants, taille = 13) => (
    <svg width={taille} height={taille} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{enfants}</svg>
);

export const IconeLien = svg(<><path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/></>);
export const IconeTelecharger = svg(<><path d="M12 4v11"/><path d="m7 10 5 5 5-5"/><path d="M5 20h14"/></>);
export const IconeChevronGauche = svg(<path d="m15 6-6 6 6 6"/>, 14);
export const IconeChevronDroite = svg(<path d="m9 6 6 6-6 6"/>, 14);
export const IconeCalques = svg(<><path d="m12 3 9 5-9 5-9-5 9-5z"/><path d="m3 12 9 5 9-5"/><path d="m3 16 9 5 9-5"/></>, 16);
export const IconeLecture = (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4v16l13-8z"/></svg>
);
export const IconePause = (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 4h4v16H6zM14 4h4v16h-4z"/></svg>
);

/** Télécharge un texte (CSV / GeoJSON) via un Blob. */
export function telecharger(nom, contenu, type) {
    const url = URL.createObjectURL(new Blob([contenu], {type}));
    const a = document.createElement('a');
    a.href = url;
    a.download = nom;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
